import Api from './api';

// Mocks desativados. Para reativar a visualizacao local sem backend, descomente
// este import e troque os retornos das funcoes pelas chamadas mock comentadas.
// import {
//   mockCreate,
//   mockDelete,
//   mockGetAssets,
//   mockGetById,
//   mockGetLayout,
//   mockGetLayouts,
//   mockGetPlaceholders,
//   mockList,
//   mockPreview,
//   mockSetActive,
//   mockUpdate,
//   mockUploadAsset,
// } from './mocks/emailtemplate.mock';

const BASE = '/emailtemplates';

const getErrors = payload => {
  const errors = payload?.errors;
  if (Array.isArray(errors)) return errors.join(' ');
  if (errors && typeof errors === 'object') {
    return Object.values(errors).flat().join(' ');
  }
  return payload?.message || '';
};

const successResult = response => ({
  success: Boolean(response.data?.success),
  data: response.data?.data,
  count: response.data?.count ?? 0,
  message: getErrors(response.data),
});

const errorResult = error => ({
  success: false,
  data: null,
  count: 0,
  message: getErrors(error.response?.data),
});

const arrayResult = result => ({ ...result, data: result.data || [] });

export const list = async parameters => {
  // Mock desativado: return mockList(parameters);
  try {
    return arrayResult(successResult(await Api.get(BASE, { params: parameters })));
  } catch (error) {
    return arrayResult(errorResult(error));
  }
};

export const getById = async id => {
  // Mock desativado: return mockGetById(id);
  try {
    return successResult(await Api.get(`${BASE}/${id}`));
  } catch (error) {
    return errorResult(error);
  }
};

export const getPredefinedLayouts = async () => {
  // Mock desativado: return mockGetLayouts();
  try {
    return arrayResult(successResult(await Api.get(`${BASE}/predefined-layouts`)));
  } catch (error) {
    return arrayResult(errorResult(error));
  }
};

export const getPredefinedLayout = async id => {
  // Mock desativado: return mockGetLayout(id);
  try {
    return successResult(await Api.get(`${BASE}/predefined-layouts/${id}`));
  } catch (error) {
    return errorResult(error);
  }
};

export const getPlaceholders = async () => {
  // Mock desativado: return mockGetPlaceholders();
  try {
    return arrayResult(successResult(await Api.get(`${BASE}/placeholders`)));
  } catch (error) {
    return arrayResult(errorResult(error));
  }
};

export const preview = async payload => {
  // Mock desativado: return mockPreview(payload);
  try {
    return successResult(await Api.post(`${BASE}/preview`, payload));
  } catch (error) {
    return errorResult(error);
  }
};

export const getAssets = async id => {
  // Mock desativado: return mockGetAssets(id);
  try {
    return arrayResult(successResult(await Api.get(`${BASE}/${id}/assets`)));
  } catch (error) {
    return arrayResult(errorResult(error));
  }
};

export const uploadAsset = async (id, file) => {
  if (id === undefined || id === null || String(id).trim() === '') {
    return { success: false, data: null, count: 0, message: '' };
  }

  // Mock desativado: return mockUploadAsset(id, file);
  const form = new FormData();
  form.append('filesUpload', file);
  try {
    return successResult(await Api.post(`${BASE}/${id}/assets`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }));
  } catch (error) {
    return errorResult(error);
  }
};

export const create = async data => {
  // Mock desativado: return mockCreate(data);
  try {
    return successResult(await Api.post(BASE, data));
  } catch (error) {
    return errorResult(error);
  }
};

export const createDraft = async data => {
  try {
    return successResult(await Api.post(`${BASE}/drafts`, data));
  } catch (error) {
    return errorResult(error);
  }
};

export const updateDraft = async (id, data) => {
  try {
    return successResult(await Api.put(`${BASE}/drafts/${id}`, data));
  } catch (error) {
    return errorResult(error);
  }
};

export const update = async (id, data) => {
  // Mock desativado: return mockUpdate(id, data);
  try {
    return successResult(await Api.put(`${BASE}/${id}`, data));
  } catch (error) {
    return errorResult(error);
  }
};

export const setActive = async (id, active) => {
  // Mock desativado: return mockSetActive(id, active);
  try {
    return successResult(await Api.put(`${BASE}/${id}/active`, { active }));
  } catch (error) {
    return errorResult(error);
  }
};

export const deleteById = async id => {
  // Mock desativado: return mockDelete(id);
  try {
    return successResult(await Api.delete(`${BASE}/${id}`));
  } catch (error) {
    return errorResult(error);
  }
};
